export default __webpack_public_path__ + "static/media/bpt-xcore.335fdd04.png";